<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "babel-polyfill";
export default {
  name: "App",
  data() {
    return {
      _role: "",
    };
  },
  watch: {
    $route: {
      deep: true,
      // immediate: true,
      handler(newv, oldv) {
        let _role = localStorage.getItem("_role");
        const isLoshi = newv.path.indexOf("laoshi") !== -1;
        const isXusheng = newv.path.indexOf("xuesheng") !== -1;
        if (_role == 4) {
          if (isLoshi) {
          } else {
            if (newv.path.indexOf("xuesheng/resultPage") == -1) {
              this.$router.push("/laoshi/myAccountPage");
            }
          }
        } else if (_role == 5) {
          if (isXusheng) {
          } else {
            this.$router.push("/xuesheng/indexPage");
          }
        }
      },
    },
  },
  mounted() {},
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
  width: 100%;
  height: 100%;
  /* background-color: #f3f3fe; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue